import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ajaxservice } from '../../../../services/ajaxservice';
import Swal from 'sweetalert2';

@Component({
  selector: 'kt-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  employee_code: string;
  roleId: any;

  constructor(public ajax: ajaxservice,private router: Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.employee_code = localStorage.getItem('pro_employee_code');
    var empid = this.employee_code;
    var url = 'fp_logout/?';             // api url for getting the details with using post params
    var id = "employee_code";                      //id for using identify the amc name
    console.log(localStorage.getItem('pro_role_id'),"localStorage.getItem('pro_role_id');")
    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to logout!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      customClass: {
        popup: 'custom-swal-popup',
        title: 'custom-swal-title',
        icon: 'custom-swal-icon',
        cancelButton: 'custom-swal-cancel',
        confirmButton: 'custom-swal-confirm',
      },
      allowOutsideClick: false,                          //sweet alert will not close on oustside click
    }).then((result) => {
      Router
      if (result.value) {
        // this.ajax.getdataparam(url, id, empid).subscribe((result) => { 
        //   if (result.response.response_code == "200") {

            localStorage.removeItem("pro_user_role");
            localStorage.removeItem("pro_employee_code");
            localStorage.removeItem("pro_employee_id");
            localStorage.removeItem("pro_org_type");
            localStorage.removeItem("pro_asideMenus");
            localStorage.removeItem("pro_user_status");
            localStorage.removeItem("pro_role_id");
            localStorage.removeItem("pro_organization_type");
            localStorage.removeItem("pro_ticket_id");
            localStorage.removeItem("pro_layoutConfig");
            localStorage.removeItem("pro_user_name");
            localStorage.removeItem("pro_language");
            localStorage.removeItem("user_code");			
            localStorage.removeItem("user_email");								
            localStorage.removeItem("user_mobile");			
            localStorage.removeItem("user_name");			
           
            //	localStorage.clear();
            // this.router.navigate(['login'])
            // window.location.reload();
            // this.toastr.success(result.response.message, 'Success');        //toastr message for success
              this.router.navigateByUrl('/customer/webform');

        //   }
        //   else if (result.response.response_code == "400") {                //if failure
        //     this.toastr.error(result.response.message, 'Error');            //toastr message for error
        //   }
        //   else {                                                         //if not sucess
        //     this.toastr.error(result.response.message, 'Error');        //toastr message for error
        //   }
        // }, (err) => {
        //   console.log(err);                                        //prints if it encounters an error
        // });
      }
      else{
        this.roleId = localStorage.getItem('pro_role_id');
        if(this.roleId == 7){
          this.router.navigateByUrl('customer/dashboard');
        }else{
          this.router.navigateByUrl('customer/new_enduser');
        }

      }
    })
  }
    // this.logout();
  }

